<template>
  <div>
    <div style="margin-bottom: 16px">
      <DecorationHead text="コンテンツの見出し" :heading-level="2" />
    </div>
    <div style="margin-bottom: 16px">
      <DecorationSubTitle text="サブタイトル（下線）" :heading-level="3" />
    </div>
    <div style="margin-bottom: 16px">
      <DecorationSubTitleSmall text="サブタイトル（左線）" :heading-level="3" />
    </div>
  </div>
</template>
<script>
import DecorationHead from '../../components/atoms/decoration/DecorationHead'
import DecorationSubTitle from '../../components/atoms/decoration/DecorationSubTitle'
import DecorationSubTitleSmall from '../../components/atoms/decoration/DecorationSubTitleSmall'

export default {
  components: { DecorationHead, DecorationSubTitle, DecorationSubTitleSmall }
}
</script>
